import { enqueueSnackbar } from 'actions';
import { GetDatasetInfoRequest, GetDatasetInfoEVORequest } from '../requests/HomeRequests';

export const GET_DATASET_INFO = 'GET_DATASET_INFO';
export const GET_DATASET_INFO_EVO = 'GET_DATASET_INFO_EVO';

const onGetDatasetInfo = (value) => ({
	type: GET_DATASET_INFO,
	DatasetInfo: value
});

const onGetDatasetInfoEVO = (value) => ({
	type: GET_DATASET_INFO_EVO,
	DatasetInfoEVO: value
});

export const GetDatasetInfo = (userId) => async (dispatch) => {
	await GetDatasetInfoRequest(userId).then(response => {
		dispatch(onGetDatasetInfo(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDatasetInfoEVO = () => async (dispatch) => {
	await GetDatasetInfoEVORequest().then(response => {
		dispatch(onGetDatasetInfoEVO(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
